import { render, staticRenderFns } from "./NameAvatar.vue?vue&type=template&id=ef664b28"
import script from "./NameAvatar.vue?vue&type=script&lang=ts"
export * from "./NameAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports